import { Flex } from '@chakra-ui/layout';
import { t } from '@lingui/macro';
import React, { ReactElement } from 'react';

import { Button } from '../../../../components/three-essentials/button/button';
import {
    BadgeContainer,
    Title,
    Description,
    IconContainer
}from './three-essentials-badge-custom.styled';

type ThreeEssentialsBadgeProps = {
    title?: string
    description?: string
    icon: ReactElement
    showButton?: boolean
    id: string
};

export const ThreeEssentialsBadgeCustom = ({
    title, icon, description, showButton, id
}: ThreeEssentialsBadgeProps) => {
    return (
        <BadgeContainer id={id}>
            <IconContainer>
                {icon}
            </IconContainer>
            <Flex direction={'column'}>
                <Title>{title}</Title>
                <Description>{description}</Description>
                { showButton && <Button title={t`threeEssentials.manage`} />}
            </Flex>
        </BadgeContainer>
    );
};
